// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"38552754","583":"13b9c3f0","845":"7a8b01e9"}[chunkId] + ".chunk.js";
};